import { FC } from "react";

export type InputJsonProps = {
  /**
   * Function that calculates the response and switches to output tab
   */
  calculate?: (value: any) => void;
  /**
   * Default values provided to WASM
   */
  defaultValues: any;
  setDefaultFormValues?: any;
};

export const InputJson: FC<InputJsonProps> = ({
  calculate,
  defaultValues,
  setDefaultFormValues,
}) => {
  return (
    <div className="w-full">
      <textarea
        className="bg-white text-sm overflow-auto rounded p-4 w-full h-64"
        rows={30}
        spellCheck={false}
        wrap="off"
        value={JSON.stringify(defaultValues, null, "\t")}
        onChange={(e) => setDefaultFormValues(JSON.parse(e.target.value))}
      />
      {calculate && (
        <div className="flex justify-center space-x-6 w-full pb-24">
          <button
            className="bg-brand-light rounded text-white py-2 px-8 mt-3 text-sm"
            type="button"
            onClick={() => setDefaultFormValues(defaultValues)}
          >
            RESET
          </button>
          <button
            className="bg-brand-light rounded text-white py-2 px-8 mt-3 text-sm"
            type="button"
            onClick={() => calculate(defaultValues)}
          >
            CALCULATE
          </button>
        </div>
      )}
    </div>
  );
};
